import { createSlice } from "@reduxjs/toolkit";

// NOTE: Removed manual storage restoration - Redux Persist handles this automatically
export const initialState: any = {
  user: {}, // Redux Persist will restore from sessionStorage
  error: "", // for error message
  loading: false,
  isUserLogout: false,
  errorMsg: false, // for error
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state: any, action: any) {
      state.error = action.payload.data;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    loginSuccess(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.errorMsg = false;
    },
    // Patch only the avatar fields on the logged-in user (profile photo
    // upload / removal). Merges so we never clobber token, profileId, etc.
    setUserAvatar(state, action) {
      if (state.user) {
        state.user.avatarUrl = action.payload?.avatarUrl ?? "";
        state.user.avatarFileName = action.payload?.avatarFileName ?? "";
      }
    },
    logoutUserSuccess(state, action) {
      state.isUserLogout = true;
      state.user = {};
    },
    reset_login_flag(state: any) {
      state.error = null;
      state.loading = false;
      state.errorMsg = false;
    },
  },
});

export const {
  apiError,
  loginSuccess,
  setUserAvatar,
  logoutUserSuccess,
  reset_login_flag,
} = loginSlice.actions;

export default loginSlice.reducer;
